export enum EAccessCodeUrls {
  ACCESS_CODE = 'access-code',
}
